import "./Sparks.css";

const Sparks = () => {
    const sparkCount = 10;

    const sparks = [];

    for (let i = 0; i < sparkCount; i++) {
        const height = 50 + Math.random() * 40;
        const duration = 8 + Math.random() * 7;
        const startLeft = Math.random() * 100;
        const drift = (Math.random() - 0.5) * 20;
        const animationOffset = -Math.random() * duration;

        const sparkStyle = {
            "--spark-delay": `${animationOffset}s`,
            "--spark-height": `${height}vh`,
            "--spark-duration": `${duration}s`,
            "--spark-start-left": `${startLeft}%`,
            "--spark-drift": `${drift}vw`,
        };

        sparks.push(<div className="spark" key={i} style={sparkStyle}></div>);
    }

    return (
        <div className="sparks">
            <div className="fire-glow"></div>
            {sparks}
        </div>
    );
};

export default Sparks;
